<template>
  <div class="people-summary">
    <div class="col sub-sub-header hide-medium">
      <a :class="{ highlight: hightlight === 'people-summary' }" class="link" @click="() => goToAndRemoveAnchor('btn-sub-header', 'people-summary')">{{
        $t('mentionedKBIS')
      }}</a>
      <a
        v-if="user.client && user.client.effectiveBeneficiariesAccess"
        :class="{ highlight: hightlight === 'people-beneficiary' }"
        class="link"
        @click="() => goToAndRemoveAnchor('people-beneficiary', 'people-beneficiary')"
        >{{ $t('beneficiariesRegistered') }}</a
      >
      <a
        :class="{ highlight: hightlight === 'people-owner-capital' }"
        class="link"
        @click="() => goToAndRemoveAnchor('people-owner-capital', 'people-owner-capital')"
        >{{ $t('capitalHolder') }}</a
      >
    </div>

    <div id="people-summary" class="col people-summary-container">
      <div class="main-button blue" @click="exportPeopleSummary">
        <div v-if="loadingExportPeopleSummary" class="lds-ellipsis">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
        <IconImport v-else class="icon" />
        {{ !loadingExportPeopleSummary ? $t('exportData') : '' }}
      </div>
      <div v-if="loading" class="lds-ring blue">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>

      <div v-if="!loading" class="title kbis-people">
        {{ $t('mentionedKBIS') }}
      </div>

      <div v-for="position in kbisMentionnated" :key="position.position" class="people-container">
        <div class="title kbis-people">
          <div class="item">Fonction</div>
          <div class="item">Nom Prénom /<br />Nom d'usage</div>
          <div class="item">Date / Lieu de naissance</div>
          <div class="item">Nationalité</div>
          <div class="item">Adresse</div>
        </div>
        <div v-for="people in position.values" :key="people.birthDate + people.denomination" class="people-content">
          <div class="item">{{ position.position }}</div>
          <div class="item">{{ people.denomination }}</div>
          <div v-if="people.birthDate" class="item">Né(e) le {{ $utils.formatDate(people.birthDate) || $t('unset') }} <br />{{ people.birthPlace }}</div>
          <div v-else class="item">{{ $t('unset') }}</div>
          <div class="item">{{ people.nationality || $t('unset') }}</div>
          <div v-if="people.address.zipCode" class="item">
            {{ people.address && people.address.lines ? people.address.lines.reduce((a, v) => `${a} ${v}`, '') : '' }}
            {{ people.address.zipCode }} {{ people.address.distribOffice }}
            {{ people.address.country }}
          </div>
          <div v-else class="item">{{ $t('unset') }}</div>
        </div>
      </div>

      <div v-if="!loading && kbisMentionnatedStatus === 1 && kbisMentionnated.length === 0" class="no-people-container">Non disponible</div>
      <div v-if="!loading && kbisMentionnatedStatus === 2" class="no-people-container">Non disponible</div>
      <div v-if="!loading && kbisMentionnatedStatus === 3" class="no-people-container">Service temporairement indisponible</div>

      <div v-if="!loading && user.client && user.client.effectiveBeneficiariesAccess" id="people-beneficiary" class="title">
        {{ $t('beneficiariesRegistered') }}
      </div>

      <div v-if="beneficiary.length && beneficiaryStatus === 1" class="people-container">
        <div class="title">
          <div class="item">Nom Prénom/ Nom d'usage</div>
          <div class="item">Date / Lieu de naissance</div>
          <div class="item">Nationalité</div>
          <div class="item">Adresse</div>
          <div class="item">% Capital / Détention</div>
          <div class="item">% Vote /<br />Détention</div>
          <div class="item">
            Autre moyen <br />
            de détention
          </div>
          <div class="item">Représentant légal</div>
          <div class="item">Date d'effet</div>
        </div>
        <div v-for="content in beneficiary" :key="content.id" class="people-content">
          <div class="item name">{{ content.denomination }}</div>
          <div v-if="content.birthDate" class="item">
            Né(e) le {{ $utils.formatDate(content.birthDate) || $t('unset') }} <br />{{ content.birthPlace || $t('unset') }}
          </div>
          <div v-else class="item">{{ $t('unset') }}</div>
          <div class="item">{{ content.nationality || $t('unset') }}</div>
          <div v-if="content.address.zipCode" class="item">
            {{ content.address && content.address.lines ? content.address.lines.reduce((a, v) => `${a} ${v}`, '') : '' }}
            {{ content.address.zipCode }} {{ content.address.distribOffice }}
            {{ content.address.country }}
          </div>
          <div v-else class="item">{{ $t('unset') }}</div>
          <div class="item percent">
            <span> {{ content.capitalDistribution ? `${content.capitalDistribution}%` : '' }}</span>
            <span>{{ content.capitalType }}</span>
          </div>
          <div class="item percent">
            <span>{{ content.voteDistribution ? `${content.voteDistribution}%` : '' }}</span>
            <span>{{ content.voteType }}</span>
          </div>
          <div class="item">
            <span>{{ content.hasAlternativeDetention || $t('unset') }}</span>
          </div>
          <div class="item">
            <span>{{ content.isLegalRepresentative || $t('unset') }}</span>
          </div>
          <div v-if="content.effectiveDate" class="item">
            {{ $utils.formatDate(content.effectiveDate) || $t('unset') }}
          </div>
          <div v-else class="item">{{ $t('unset') }}</div>
        </div>
      </div>

      <div v-if="!loading && beneficiaryStatus === 1 && beneficiary.length === 0" class="no-people-container">Non disponible</div>
      <div v-if="!loading && beneficiaryStatus === 2" class="no-people-container">Non disponible</div>
      <div v-if="!loading && beneficiaryStatus === 3" class="no-people-container">Service temporairement indisponible</div>

      <div v-if="!loading" id="people-beneficiary" class="title">
        {{ $t('capitalHolder') }}
      </div>

      <div v-if="capitalOwner.length" id="people-owner-capital" class="people-container">
        <div class="title">
          <div class="item">Nom Prénom/ Nom d'usage</div>
          <div class="item">
            Personne <br />
            Physique / Morale
          </div>
          <div class="item">Date / Lieu de naissance</div>
          <div class="item">Nationalité</div>
          <div class="item">Adresse</div>
          <div class="item">% Capital</div>
          <div class="item">Nombre de parts</div>
        </div>
        <div v-for="content in capitalOwner" :key="content.id" class="people-content">
          <div class="item name">{{ content.denomination }}</div>
          <div class="item name">{{ content.legalType }}</div>
          <div v-if="content.birthDate" class="item">Né(e) le {{ $utils.formatDate(content.birthDate) || $t('unset') }} <br />{{ content.birthPlace }}</div>
          <div v-else class="item">{{ $t('unset') }}</div>
          <div class="item">{{ content.nationality || $t('unset') }}</div>
          <div v-if="content.address.zipCode" class="item">
            {{ content.address && content.address.lines ? content.address.lines.reduce((a, v) => `${a} ${v}`, '') : '' }}
            {{ content.address.zipCode }} {{ content.address.distribOffice }}
            {{ content.address.country }}
          </div>
          <div v-else class="item">{{ $t('unset') }}</div>
          <div class="item">
            {{ content.capitalDistribution ? `${content.capitalDistribution}%` : $t('unset') }}
          </div>
          <div class="item">
            {{ content.sharesNumber ? `${content.sharesNumber}` : $t('unset') }}
          </div>
        </div>
      </div>

      <div v-if="!loading && capitalOwnerStatus === 1 && capitalOwner.length === 0" class="no-people-container">Non disponible</div>
      <div v-if="!loading && capitalOwnerStatus === 2" class="no-people-container">Non disponible</div>
      <div v-if="!loading && capitalOwnerStatus === 3" class="no-people-container">Service temporairement indisponible</div>

      <div v-if="error" class="error-message">
        <div class="icon-error" />
        {{ $t('anErrorOccured') }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import throttle from '@/utils/throttle';

export default {
  props: {
    company: {
      type: Object,
      required: true,
    },

    isMonitored: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      kbisMentionnated: [],
      kbisMentionnatedStatus: 0,
      beneficiary: [],
      beneficiaryStatus: 0,
      capitalOwner: [],
      capitalOwnerStatus: 0,
      loading: false,
      hightlight: 'people-summary',
      peoples: null,
      error: null,
      loadingExportPeopleSummary: false,
    };
  },

  computed: {
    ...mapGetters(['user']),
  },

  created() {
    if (!this.isMonitored) {
      this.$router.push({ name: 'searchByIdEnterprise', replace: true });
    }
  },

  async mounted() {
    try {
      this.loading = true;
      this.error = false;
      this.peoples = await this.$store.dispatch('getCompanyPeople', {
        searchedCompanySiren: this.company.siren,
      });
      this.kbisMentionnated = this.peoples.executivesEnvelope.status.code === 1 ? this.peoples.executivesEnvelope.values : [];
      this.kbisMentionnatedStatus = this.peoples.executivesEnvelope.status.code;
      this.beneficiary = this.peoples.effectifBeneficiariesEnvelope.values;
      this.beneficiaryStatus = this.peoples.effectifBeneficiariesEnvelope.status.code;
      this.capitalOwner = this.peoples.capitalHoldersEnvelope.values;
      this.capitalOwnerStatus = this.peoples.capitalHoldersEnvelope.status.code;
      window.addEventListener('scroll', this.handleScroll);
      this.loading = false;
    } catch {
      this.error = true;
      this.loading = false;
    }
  },

  unmounted() {
    window.removeEventListener('scroll', this.handleScroll);
  },

  methods: {
    goToAndRemoveAnchor(anchor, hightlight) {
      this.hightlight = hightlight;
      var url = location.href;
      location.href = '#' + anchor;
      history.replaceState(null, null, url);
    },

    isInViewport(anchor) {
      const el = document.querySelector(`#${anchor}`);
      if (!document.querySelector(`#${anchor}`)) return;
      return this.$utils.isInViewport(el);
    },

    handleScroll: throttle(function () {
      if (!this) return;
      if (this.isInViewport('people-owner-capital')) {
        this.hightlight = 'people-owner-capital';
        if (this.isInViewport('btn-sub-header')) {
          this.hightlight = 'people-summary';
          return;
        }
        return;
      }
      if (this.isInViewport('people-beneficiary')) {
        this.hightlight = 'people-beneficiary';
        if (this.isInViewport('btn-sub-header')) {
          this.hightlight = 'people-summary';
          return;
        }
        return;
      }
      if (this.isInViewport('btn-sub-header')) {
        this.hightlight = 'people-summary';
      }
    }, 50),

    async exportPeopleSummary() {
      this.loadingExportPeopleSummary = true;
      const result = await this.$store.dispatch('exportCompanyPeople', {
        siren: this.company.siren,
      });
      const content = result.headers['content-disposition'];
      const filename = content
        .split(';')
        .find(n => n.includes('filename='))
        .replace('filename=', '');
      const url = window.URL.createObjectURL(new Blob([result.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      const child = document.body.appendChild(link);
      link.click();
      child.remove();
      window.URL.revokeObjectURL(url);
      this.loadingExportPeopleSummary = false;
    },
  },
};
</script>

<style scoped lang="scss">
@use '@/styles/colors.scss';
@use '@/styles/responsive.scss';
@use '@/styles/fonts.scss';
.people-summary {
  width: 100%;
  display: flex;
  padding: 60px 12px 80px;
  box-sizing: border-box;

  .col {
    &.sub-sub-header {
      flex-grow: 1;
      width: 200px;
      max-height: 200px;
      padding-right: 36px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      position: sticky;
      top: 110px;

      .link {
        margin: 0 0 20px;
        font-weight: 500;
        font-size: 18px;
        color: colors.$grey-color;
        width: 100%;

        &.highlight {
          color: colors.$black-color;
        }

        &:hover {
          cursor: pointer;
          color: rgba(colors.$black-color, 0.8);
        }
      }
    }

    &.people-summary-container {
      display: flex;
      padding-left: 36px;
      border-left: 1px solid colors.$lightgrey-color;
      flex-grow: 1;
      flex-direction: column;
      width: 100%;

      .title {
        color: colors.$darkblue-color;
        font-weight: 500;
        font-size: 20px;
        margin: 0 0 24px;
      }

      .no-people-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        background: colors.$unread-table-color;
        margin: 20px 0;
        border-radius: 5px;
        padding: 30px;
      }

      .people-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        background: colors.$unread-table-color;
        margin: 20px 0;
        border-radius: 5px;
        padding: 15px;

        .title {
          font-weight: 500;
          font-size: 14px;
          color: colors.$lightblue-color;
          margin: 0;
          height: 24px;
          align-self: flex-start;
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 100%;
          padding-bottom: 10px;

          .item {
            width: 100%;
            padding-left: 20px;

            &:first-child {
              padding-left: 0;
            }
          }
        }

        .people-content {
          flex-grow: 1;
          padding: 20px 0 20px;
          position: relative;
          width: 100%;
          display: flex;

          &:not(:first-child):before {
            position: absolute;
            content: '';
            top: 0;
            height: 1px;
            width: 100%;
            background: rgba(colors.$lightblue-color, 0.3);
          }

          .item {
            width: 100%;
            padding-left: 20px;
            font-size: 13px;
            color: colors.$darkgrey-color;

            &:first-child {
              padding-left: 0;
            }
          }
        }
      }
    }
  }
}

.item.percent {
  display: flex;
  flex-direction: column;

  span {
    margin-bottom: 6px;
  }
}

.main-button {
  &.blue {
    max-width: 326px;
    background: colors.$lightblue-color;
    border-radius: 5px;
    font-size: 14px;
    font-weight: 500;
    padding: 8px 12px;
    margin: 0 0 24px auto;

    .icon {
      margin-right: 8px;
    }
  }
}

@media only screen and (max-width: responsive.$layout-breakpoint-small) {
  .people-summary-container {
    border: none !important;
    padding-left: 0 !important;
  }

  .people-summary {
    padding-bottom: 0 !important;
  }

  .people-content {
    flex-direction: column;

    .item {
      margin: 8px 0 !important;
      padding: 0 !important;
    }

    .item.name {
      font-weight: bold;
    }

    .item:last-child {
      margin-bottom: 0 !important;
    }

    .item:first-child {
      margin-top: 0 !important;
    }
  }
}

.error-message {
  height: 32px;
  margin: -8px 0 8px;
  font-size: 14px;
  color: colors.$error-color;
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon-error {
  margin: 0 6px 0 0;
  position: relative;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 2px solid colors.$red-color;
  flex-shrink: 0;
  transform: scale(0.8);

  &:after {
    position: absolute;
    content: '';
    bottom: 3px;
    left: calc(50% - 1px);
    right: calc(50% - 1px);
    height: 8px;
    background: colors.$red-color;
  }

  &:before {
    position: absolute;
    content: '';
    top: 3px;
    left: calc(50% - 1px);
    right: calc(50% - 1px);
    height: 2px;
    background: colors.$red-color;
  }
}
</style>
